import { Controller } from "@hotwired/stimulus";

export class TooltipController extends Controller<HTMLElement> {

    private tippyInstance: { destroy: () => void };

    connect(): void {
        this.tippyInstance = (<any>window).tippy(this.element);
    }

    disconnect(): void {
        this.tippyInstance.destroy();
    }
}
